export const orderTextStyle = {
  width: "260px",
  height: "40px",
  marginLeft: "48px",

  "& .MuiOutlinedInput-input": {
    background: "#F5F5F5",
    padding: "10px 16px 10px 0px !important",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "unset",
  },
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#F5F5F5",
  },
};

export const AddItemStyle = {
  p: "12px 32px",
  height: "44px",
  width: "151px",
  border: "1px solid #CCD1DB",
};

export const gridIconsCss = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#212121",
};

const nutritionTableStyle = {
  width: "100%",
  "& .MuiDataGrid-root": {
    border: "1px solid #EEEEEE",
    borderRadius: "8px",
    color: "#212121",

    "& .MuiDataGrid-footerContainer": {
      borderTop: "1px solid #EEEEEE",
    },
    "& .MuiDataGrid-columnHeaders": {
      background: "#F5F5F5",
      borderBottom: "1px solid #EEEEEE",
    },
    "& .MuiDataGrid-cell": {
      borderBottom: "1px solid #EEEEEE",
    },
    "& .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
      {
        outline: "none",
      },
  },
};

const bulkBrandCategoryStyle = {
  "& .MuiSvgIcon-root": {
    color: "#212121",
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },

  "& .MuiOutlinedInput-root input::placeholder": {
    color: "#212121",
    opacity: 1,
    fontSize: 13,
    fontWeight: "500",
  },

  "& .MuiOutlinedInput-root": {
    height: "41px",
    borderRadius: "58px",
    background: "#F5F5F5",

    "& fieldset": {
      borderColor: "#bababa",
      borderWidth: 0.8,
    },
    "&:hover fieldset": {
      borderColor: "#e51451",
    },
    "&.Mui-focused fieldset": {
      borderWidth: 0.8,
      borderColor: "#e51451",
    },
    "&.MuiOutlinedInput-root input": {
      color: "#212121",
      fontSize: 13,
      fontWeight: "500",
    },

    "&.MuiOutlinedInput-root .MuiTypography-root": {
      color: "#545454",
      fontSize: 13,
      fontWeight: "200",
    },
    "& .MuiOutlinedInput-input": {
      padding: "2px !important",
      background: "#F5F5F5",
    },
  },
};

const headerGrid12Style = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  p: "40px 40px 0 !important",
};

const footerGrid12Style = {
  display: "flex",
  alignItems: "center",
  justifyContent: "end",
};

const footerCancelBtnStyle = {
  p: "12px 44.5px",
  background: "#F5F5F5",
  color: "#212121",
  "&:hover": {
    backgroundColor: "#F5F5F5",
  },
};

const cardHeaderBtnGridStyle = {
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
};

const filterGrid12Style = {
  display: "flex",
  alignItems: "center",
  mb: "16px",
};

const categorySortGridStyle = {
  display: "flex",
  justifyContent: "end",
};

const setsTableStyle = {
  width: "100%",
  mb: "30px",

  "& .MuiDataGrid-root": {
    border: "none",

    "& .MuiDataGrid-columnHeaderCheckbox": {
      width: "unset !important",
      minWidth: "unset !important",
    },
    "& .MuiDataGrid-cellCheckbox": {
      minWidth: "unset !important",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      color: "#212121",
    },
    "& .MuiDataGrid-cellContent": {
      color: "#212121",
    },
    "& .MuiDataGrid-footerContainer": {
      borderTop: "1px solid #EEEEEE",
    },
    "& .MuiDataGrid-columnHeaders": {
      borderBottom: "1px solid #EEEEEE",
    },
    "& .MuiDataGrid-cell": {
      borderBottom: "1px solid #EEEEEE",
    },
    "& .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-row": {
      cursor: "pointer",
    },
    "& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
      {
        outline: "none",
      },
  },
};

const cellBtnStyles = {
  fontWeight: 400,
  p: "unset",
  color: "#DB154D",
  "&:hover": {
    backgroundColor: "transparent",
  },

  "& .MuiButton-startIcon": {
    mr: "unset",
  },
};

const cancelItemUpdateBtnStyle = {
  fontWeight: 400,
  p: "unset",
  ml: "25px",
  color: "#24335E",

  "&:hover": {
    backgroundColor: "transparent",
  },
};

const addIconBtnStyle = {
  background: "#24335E",
  borderRadius: "8px",
  height: "48px",
  width: "48px",
  ml: "7px",
  "&:hover": {
    backgroundColor: "#24335E",
  },
};

export const deleteIconBtnStyle = {
  background: "#D84315",
  borderRadius: "8px",
  height: "48px",
  width: "48px",
  ml: "7px",
  "&:hover": {
    backgroundColor: "#D84315",
  },
};

export const textAreaStyles = {
  "& .MuiOutlinedInput-root": {
    height: "unset !important",
  },

  mb: "24px",
};

export const allColumnCategoryCheckboxStyles = {
  mb: "10px",
  width: "fit-content",

  "& .MuiFormControlLabel-label": {
    fontSize: "18px",
    fontWeight: 600,
  },
};

export const productPriceStyles = {
  fontFamily: "Roboto",
  fontStyle: "normal",
  fontWeight: "400",
  fontSize: "10px",
  color: "#757575",
  lineHeight: "20px",
};

export const productPriceSx = { color: "#212121", ml: "3px" };

export const resetButtonStyles = {
  textDecoration: "underline",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  p: "10px",
  height: " 30px",
  borderRadius: "12px",
  fontFamily: "Roboto",
  fontStyle: "normal",
  lineHeight: "15px",
  ml: "16px",
  backgroundColor: "#D2FFDF",
  color: "#00C853",
};

export const toggleSwitchStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  mb: "18px",
};

export const switchMarginUnset = {
  "& .MuiFormControlLabel-root": {
    m: "unset",
  },
};

export const tooltip = {
  backgroundColor: "#000",
  color: "#fff",
  borderRadius: 6,
  padding: "5px",
};
export const headerButtonMobile = {
  padding: "6px 16px !important",
  width: "100% !important",
  marginTop: "12px",
};

export const headerButton = {
  padding: "12px 24px !important",
};
export const searchFieldStyle = {
  width: { xs: "100%", sm: "100%", md: "260px" },
  height: "44px",
  marginLeft: { xs: "unset", sm: "5px", md: "10px", lg: "48px" },
  marginTop: { xs: "12px", sm: "unset" },

  "& .MuiOutlinedInput-input": {
    background: "#F5F5F5",
    padding: "10px 16px 10px 0px !important",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "unset",
  },
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#F5F5F5",
  },
};

export const searchFieldStyleMobile = {
  width: "100% !important",
  marginLeft: "unset",
};

export {
  nutritionTableStyle,
  bulkBrandCategoryStyle,
  headerGrid12Style,
  footerGrid12Style,
  footerCancelBtnStyle,
  cardHeaderBtnGridStyle,
  filterGrid12Style,
  categorySortGridStyle,
  setsTableStyle,
  cellBtnStyles,
  cancelItemUpdateBtnStyle,
  addIconBtnStyle,
};
